import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceHappySVG = function FaceHappySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm-4 9a2 2 0 11-2 2 2 2 0 012-2zm9.71 9.71A8.5 8.5 0 0116 23a8.5 8.5 0 01-5.71-2.29 1 1 0 011.42-1.42 6.24 6.24 0 008.58 0 1 1 0 011.42 1.42zM20 15a2 2 0 112-2 2 2 0 01-2 2z"
  }));
};
FaceHappySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceHappySVG);